<div class="nav">
    <mat-toolbar>
        <button
            mat-icon-button
            *ngIf="!isMSTeams"
            aria-label="Toggle side navigation panel"
            color="primary"
            (click)="handleToggleNavPanel()"
        >
            <mat-icon>menu</mat-icon>
        </button>
        <span
            class="title"
            data-testid="nav-header-title"
            >{{ title }}</span
        >
        <span class="spacer"></span>

        <div class="toolbar actions">
            <button
                mat-button
                *ngIf="(isFreeUser || isTrialUser) && !isMSTeams"
                color="primary"
                (click)="goTo('settings.billing')"
            >
                <i class="icon rocket"></i>
                Upgrade
            </button>

            <button
                mat-button
                *ngIf="!isMSTeams"
                (click)="openTab('https://faq.calendarhero.com/hc/en-us/')"
            >
                <i class="ui question circle outline blue large icon"></i> <span class="no-mobile">Help</span>
            </button>

            <button
                mat-button
                [matMenuTriggerFor]="menu"
                aria-label="Menu to manage your account"
            >
                <i class="ui user circle blue icon"></i>
                <span class="no-mobile">My Account</span>
            </button>
            <mat-menu #menu="matMenu">
                <button
                    mat-menu-item
                    (click)="goTo('user')"
                >
                    My Profile Settings
                </button>
                <button
                    mat-menu-item
                    *ngIf="showBillingLink"
                    (click)="goTo('settings.billing')"
                >
                    Billing Plan
                </button>

                <ng-container *ngIf="!isPlatformUser">
                    <button
                        mat-menu-item
                        (click)="goTo('skills.list')"
                    >
                        CalendarHero Applications
                    </button>

                    <button
                        mat-menu-item
                        (click)="goTo('invite')"
                    >
                        Invite Your Coworkers
                    </button>

                    <button
                        mat-menu-item
                        (click)="goTo('logout')"
                    >
                        Log Out
                    </button>
                </ng-container>
            </mat-menu>
        </div>
    </mat-toolbar>
</div>
